import { useObserver, useSubtree } from "subtree.js/react";
import { CustomerTabs } from "../../components/CustomerTabs";
import { ShopQr } from "../../sections/customer-qr/customer-qr-modal";
import { ShopQrState } from "./shop-qr-controller";

export function ShopQrPage() {
  const state = useSubtree(ShopQrState);
  const observer = useObserver();
  const shopName = observer.watch(state.shopName);
  const openCarts = observer.watch(state.openCarts);
  return (
    <div className="mx-auto max-w-4xl px-2 py-4 sm:px-6 sm:py-8 lg:px-8">
      <div className="panel p-4 sm:p-6">
        <CustomerTabs active="qr" openCarts={openCarts} customer={state.customerId} />
        <div className="mx-auto max-w-sm py-2">
          <ShopQr shopName={shopName} />
        </div>
      </div>
    </div>
  );
}
